<template>
    <div class="form-group d-flex attachmentUploader">
        <div>
            <label>{{label}}</label>
            <div>
                <template v-if="canUpload">
                    <file-input class="form-control" v-model="fileToUpload"></file-input>
                </template>
                <template name="cant" v-else>
                    Salva prima di caricare allegati
                </template>
            </div>
            <div class="mt-2">
                <button class="btn btn-primary" @click="uploadFile" :disabled="!fileToUpload">
                    Carica
                </button>
            </div>
        </div>
        <div>
            <slot name="preview">
                <img style="max-height: 120px;" :src="localValue.publicUrl" v-if="localValue && localValue.publicUrl" />
            </slot>
        </div>
    </div>
</template>

<script lang="ts">
import WithModel from '@/mixins/withModel';
import { mixins, Options, Vue } from 'vue-class-component';
import * as OM from '@/model';
import { Prop } from 'vue-property-decorator';
import {UploadServices} from '@/services/UploadServices';

@Options({})
export default class attachmentUploader extends mixins(WithModel) {

    @Prop() label: string;
    @Prop() canUpload: boolean;

    fileToUpload: File = null;

    declare modelValue: OM.Attachment;

    uploadFile(){
        UploadServices.UploadFile({
            entityIdentifier: "",
            file: this.fileToUpload
        })
        .then(x => {
            this.emitModel(x);
        })
    }

}

</script>

<style lang="css" scoped>

    .attachmentUploader img {
        max-width: 100%;
    }
    
</style>